import Storage from "../storage";

export default function getCampaignPromocode() {
  return Storage.courses.promocode || new URLSearchParams(window.location.search).get('promocode');
}
